import * as React from 'react';
import { FormGroup, Label, Input } from '../../../components/Bootstrap';
import { FufillmentCentersQuery_deliveryConfigurations } from '../__generated__/FufillmentCentersQuery';

type DeliveryValueRowProps = {
  field: FufillmentCentersQuery_deliveryConfigurations['deliveryFields'][number];
  value: string;
  onChange(key: string, value: string);
};

export const DeliveryValueRow: React.FC<DeliveryValueRowProps> = ({ value, field, onChange }) => {
  const onChangeValue: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    const newValue = e.target.value;
    onChange(field.key, newValue);
  };

  return (
    <FormGroup className='fulfillment-center-modal-input'>
      <Label>{field.label}</Label>
      <Input value={value} onChange={onChangeValue} />
    </FormGroup>
  );
};
